import { AxiosError } from "axios";
import { BoardUserRoleModel } from "models/BoardUserRoleModel";
import { createContext } from "react";

export interface IBoardUsersContext {
  boardUsers: BoardUserRoleModel[];
  error?: AxiosError;
  isLoading: boolean;
  isBoardOwner: boolean;
  isBoardMember: boolean;
  reloadBoardUsers: () => Promise<void>;
}

export const BoardUsersContext = createContext({} as IBoardUsersContext);
